import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../../model/rodeo';
import { Team } from '../../../../../model/team';

@Component({
    selector: 'team-select',
    templateUrl: 'team-select.html'
})
export class TeamSelectPopup {
    team: Team;
    teams: Team[];

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.teams = navParams.get('teams');

        this.team = this.teams[0];
    }

    openSearch() {
        this.viewController.dismiss({ team: this.team });
    }

    cancel() {
        this.viewController.dismiss({});
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/results/teams/team-select.ts